/*
 * @Author: wuchenge
 * @Date:   2022-03-23 17:53:22
 * @Last Modified by:   无尘阁
 * @Last Modified time: 2022-04-07 12:03:17
 */
import * as types from "./types";

export const changHomeTopics = (ids) => {
  return {
    type: types.HOME_CHANGE_LABELIDS,
    ids,
  }
};
